import { ReactNode } from 'react';
import { mergeClasses } from '@fluentui/react-components';

import { useDefaultTemplateStyles } from './DefaultTemplate.styles';

export type DefaultTemplateProps = {
  children?: ReactNode
  className?: string
  header?: ReactNode
  preFooter?: ReactNode
  footer?: ReactNode
};

const DefaultTemplate: React.FC<DefaultTemplateProps> = (props: DefaultTemplateProps) => {
  const { className, children, footer, header, preFooter } = props;
  const classes = useDefaultTemplateStyles();
  const preFooterSection = preFooter && (
    <section className={mergeClasses('pre-footer', classes.preFooter)}>
      <div className={classes.preFooterContent}>{preFooter}</div>
    </section>
  );

  return (
    <div className={mergeClasses('default-template', classes.page, className)}>
      <header className={mergeClasses('header', classes.header)}>
        <div className={classes.headerContent}>{header}</div>
      </header>

      <main className={mergeClasses('main', classes.main)}>
        <div className={classes.mainContent}>{children}</div>
      </main>

      {preFooterSection}

      <footer className={mergeClasses('footer', classes.footer)}>
        <div className={classes.footerContent}>{footer}</div>
      </footer>
    </div>
  );
};

export default DefaultTemplate;
